export * from './veranstaltungsTypenCommand.service';
import { VeranstaltungsTypenCommandService } from './veranstaltungsTypenCommand.service';
export * from './veranstaltungsTypenQuery.service';
import { VeranstaltungsTypenQueryService } from './veranstaltungsTypenQuery.service';
export * from './veranstaltungsTypenTemplates.service';
import { VeranstaltungsTypenTemplatesService } from './veranstaltungsTypenTemplates.service';
export const APIS = [VeranstaltungsTypenCommandService, VeranstaltungsTypenQueryService, VeranstaltungsTypenTemplatesService];
